$(document).ready(function(){

  if($('.scrol_contnet').length > 0){
  
    $('.scrol_contnet').removeClass('hidden');
    
    $('.str3-2').liMarquee({
       circular:true,
       startShow:true,
       scrollDelay: 0,
       direction: 'left'
    });
    
  }

  $('.banner-left-btn-cls button').on('click',function(){
    $('html, body').animate({
      scrollTop: $(".shopify-section--featured-collection [scnd-lay]").offset().top - 50
    }, 200);
  }); 

  $(document).on('change','.cstm-opt-var',function(){
    var varoo = window.location.href.split('variant=')[1];
    $('.variant-metacstm p').each(function(){
        var idd = $(this).attr('data-attr');
        if(varoo == idd){
            $(this).addClass('active');
        }else{
            $(this).removeClass('active');
        }
    })
  })
  
  if ($('.variant-metacstm p').length > 0) {
    var varoo = window.location.href.split('variant=')[1];
    if(typeof varoo !== 'undefined' && varoo !== '') {
      $('.variant-metacstm p').each(function() {
          var idd = $(this).attr('data-attr');
          if (varoo == idd) {
              $(this).addClass('active');
          } else {
              $(this).removeClass('active');
          }
      });
    }
  }

  $(document).on('change','.cstm-opt-var',function(){
    var lbl = $(this).parents('.variant-picker__option').find('.variant-picker__option-info legend span').text().trim();
    if(lbl == 'paddle type:'){
        var slc = $(this).parents('.variant-picker__option').find('.variant-picker__option-info variant-option-value').text().trim();
        $('.product-info__title span').text(slc);
    }
  })

  if ($('.variant-picker__option').length > 0) {
    $('.variant-picker__option').each(function(){
      var lbl = $(this).find('.variant-picker__option-info legend span').text().trim();
      if(lbl == 'paddle type:'){
      var slc = $(this).find('.variant-picker__option-info variant-option-value').text().trim();
      $('.product-info__title span').text(slc);
      }
    })
  }


  // $(document).on('change','.cstm-opt-var input',function(){
  //   let price = $(this).attr("data-price");
  //   let cprice = $(this).attr("data-cprice");
  //   $('.custom--buy-btn-wrapper .button[type="submit"] .custom--atc-price em').text(price);
  //   $('.custom--buy-btn-wrapper .button[type="submit"] .custom--atc-price sup').text(cprice);
  // })

  
})

$(".custom-apl-video-overlay").click(function(){
  $(this).fadeOut(300);
  $(this).parent().find(".custom-apl-video-play").fadeOut(300);
  $(this).parent().find(".custom-apl-video-vid").trigger("play");
})

$(document).on("click",".custom-qty-inp-plus" ,function(){
  let v = parseInt($(this).parent().find(".quantity-input").val()) + 1;
  $(this).parent().find(".quantity-input").val(v);
  $(this).parent().find(".quantity-input")[0].dispatchEvent(new Event("change", { bubbles: true }));
});

$(document).on("click",".custom-qty-inp-minus" ,function(){
  let v = parseInt($(this).parent().find(".quantity-input").val()) - 1;
  $(this).parent().find(".quantity-input").val(v);
  $(this).parent().find(".quantity-input")[0].dispatchEvent(new Event("change", { bubbles: true }));
});